import {
  CardStyleInterpolators,
  StackScreenProps,
} from "@react-navigation/stack";
import {
  CreateStockOrderRootScreenParamList,
  StockOrderRootParamList,
} from "../../../../types";
import {
  ModalCloseButton,
  createStackHeaderNavigator,
} from "@towersystems/roam-common-native";
import { CreateStockOrderScreen } from "../CreateStockOrderScreen";
import { StockOrderDetailsForm } from "../../components/StockOrderDetailsForm";
import { SelectLocationModalScreen } from "../../../../components/SelectLocationModalScreen";

export type CreateStockOrderRootScreenProps = StackScreenProps<
  StockOrderRootParamList,
  "CreateStockOrderRootScreen"
>;

export const CreateStockOrderRootScreen =
  ({}: CreateStockOrderRootScreenProps) => {
    const Drawer =
      createStackHeaderNavigator<CreateStockOrderRootScreenParamList>();

    return (
      <StockOrderDetailsForm.Provider>
        <Drawer.Navigator
          screenOptions={{
            title: "",
            animationEnabled: true,
            headerLeft: () => <ModalCloseButton type="Cancel" />,
          }}
        >
          <Drawer.Screen
            name="CreateStockOrderScreen"
            component={CreateStockOrderScreen}
          />
          <Drawer.Group
            screenOptions={{
              cardStyleInterpolator: CardStyleInterpolators.forHorizontalIOS,
            }}
          >
            <Drawer.Screen
              name="SelectLocationModalScreen"
              component={SelectLocationModalScreen}
            />
          </Drawer.Group>
        </Drawer.Navigator>
      </StockOrderDetailsForm.Provider>
    );
  };
